import { createSlice } from '@reduxjs/toolkit';

// Initial state of the authentication slice
const initialState = {
  isLoggedIn: false,
  user: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // Action to handle user login
    login: (state, action) => {
      state.isLoggedIn = true;
      state.user = action.payload.user;
    },
    
    // Action to handle user logout
    logout: (state) => {
      state.isLoggedIn = false;
      state.user = null;
    },
  },
});

// Export actions to be dispatched
export const { login, logout } = authSlice.actions;

// Export the reducer to be used in the store
export default authSlice.reducer;
